<template>
     <div class="page-content">
  <script data-n-head="true" type="application/ld+json">{
      "@context":"http://schema.org",
      "@type":"BreadcrumbList","itemListElement":[
          {
              "@type":"ListItem",
              "position":1,
              "item":"https://GameEnable.com/faq",
               "name":"FAQ"
          }
      ]
  }</script>
           <v-row>
    <v-col cols="12" sm="12" >
        <h1 class="page-title"> <span v-html="$t('faq.title')"></span></h1>
      <v-card>
        <v-list two-line>
          <template v-for="(item, index) in items">
            <v-subheader v-if="item.header" :key="item.header">{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider" :key="index" :inset="item.inset" style="margin-left: 10px; max-width: calc(100% - 20px);"></v-divider>
            <v-list-item v-else :key="item.title" >

              <v-list-item-content>
                <v-list-item-title v-html="'+ ' + item.title"></v-list-item-title>
                <div  v-html="item.subtitle" class="wrap-text" style="margin-top:15px;margin-bottom:10px;padding-left:10px;color: rgba(0, 0, 0, 0.6); font-size:14px;"></div>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-card>

        <v-card
              style="margin-top:20px;"
                class="mx-auto"
        >



    <v-card-text style="padding-right:100px;">
      <span v-html="$t('faq.socialMedia')"></span>
    </v-card-text>

    <v-card-actions style="    position: absolute;right: 0;bottom: 0;">
      <v-spacer></v-spacer>
      <v-btn href="mailto: gameenable.com@gmail.com" icon>
        <v-icon>mdi-email</v-icon>
      </v-btn>
      <v-btn icon target="_blank" href="https://twitter.com/enablegame">
        <v-icon>mdi-twitter</v-icon>
      </v-btn>
      <v-btn icon target="_blank" href="https://discord.gg/V6fv3Nx">
        <v-icon>mdi-discord</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>

    </v-col>



  </v-row>

        </div>
</template>

<style>



  .text-action {

    color: #EF44AE;
    background: linear-gradient(90deg, rgba(255,81,82,1) 0%, rgba(255,55,117,1) 49%, rgba(254,0,148,1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

  }
  .page-title {
    font-weight:300;font-size:27px;margin-top:5px;margin-bottom:15px;
  }

  .mobile .page-title {
    text-align: center;
  }

</style>

<script>



  import i18n from '@/i18n';
  import Page from '../mixins/page'


  export default {
    name: 'FAQ',
    mixins: [Page],
    computed: {
      pageTitle(){
        return i18n.t('faq.pageTitle');
      },
      pageDescription(){
        return i18n.t('faq.pageDescription');
      },
      items() {return [
        { header: i18n.t('faq.accountTitle') },
        {  title: i18n.t('faq.cancelBeforeFirstPaymentQuestion'), subtitle: i18n.t('faq.cancelBeforeFirstPaymentAnswer') },
        { divider: true, inset: true },
        {  title: i18n.t('faq.cancelSubscriptionQuestion'), subtitle: i18n.t('faq.cancelSubscriptionAnswer') },
        { divider: true, inset: true },
        {  title: i18n.t('faq.registerInUnsupportedCountryQuestion'), subtitle: i18n.t('faq.registerInUnsupportedCountryAnswer') },
        { divider: true, inset: true },
        { header: i18n.t('faq.securityAndPerformanceTitle') },
        {  title: i18n.t('faq.canUseWithTVQuestion'), subtitle: i18n.t('faq.canUseWithTVAnswer') },
        { divider: true, inset: true },
        {  title: i18n.t('faq.canUseOnMobileQuestion'), subtitle: i18n.t('faq.canUseOnMobileAnswer') },
        { divider: true, inset: true },
        {  title: i18n.t('faq.canUseOnPCMacLinuxQuestion'), subtitle: i18n.t('faq.canUseOnPCMacLinuxAnswer') },
        { divider: true, inset: true },
        {  title: i18n.t('faq.willMakeInternetFasterQuestion'), subtitle: i18n.t('faq.willMakeInternetFasterAnswer') },
        { divider: true, inset: true },
        {  title: i18n.t('faq.slowDownInternetQuestion'), subtitle: i18n.t('faq.slowDownInternetAnswer') },
        { divider: true, inset: true },
        {  title: i18n.t('faq.fasterThanVPNQuestion'), subtitle: i18n.t('faq.fasterThanVPNAnswer') },
        { divider: true, inset: true },
        {  title: i18n.t('faq.trafficGoesThroughServersQuestion'), subtitle: i18n.t('faq.trafficGoesThroughServersAnswer') },
        { divider: true, inset: true },
        {  title: i18n.t('faq.differenceBetweenStadiaAndVPNQuestion'), subtitle: i18n.t('faq.differenceBetweenStadiaAndVPNAnswer') },



      ];}
    }
  };
</script>
